import { configureStore, createReducer } from "@reduxjs/toolkit";
import {
  singleSelectReducer,
  multiSelectReducer,
  questionActionTranslator,
} from "@labxchange/ui-components";

const dataAttributes = {};

/**
 * Store - Redux store for scrollable app.
 * Includes question reducers for SingleSelectQuestion and MultiSelectQuestion
 * rendered via Widget-Container in scrollable content.
 */
export const Store = configureStore({
  reducer: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dataAttributes: createReducer(dataAttributes, () => {}),
    cscq: singleSelectReducer,
    mscq: multiSelectReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(questionActionTranslator),
});
